export default __webpack_public_path__ + "static/ak-cached/24h/media/carnegie hall+.d0294256.png";